import {Pipe, PipeTransform} from '@angular/core';
import {NavService} from "../services/nav.service";

@Pipe({
    name: 'filter'
})
export class FilterPipe implements PipeTransform {

    constructor(private navService: NavService) {
    }

    transform(items: any[], searchText: string, key: string): any[] {
        if (!items || !searchText || !key) {
            this.navService.expanded = false;
            return items;
        }

        searchText = searchText.toLowerCase();

        return items
            .map(item => {
                if (key === 'displayName') {
                    // For navItems, return only matching display names
                    return item.displayName?.toLowerCase().includes(searchText) ? item : null;
                }
                if (key === 'name') {
                    // Check if the module_name itself matches
                    const moduleMatches = item.module_name.toLowerCase().includes(searchText);

                    // Filter only matching menus
                    const filteredMenus = item.menus?.filter((menu: { name: string; }) =>
                        menu.name.toLowerCase().includes(searchText)
                    );

                    // If any menus match, return the module with filtered menus
                    if (filteredMenus.length) {
                        this.navService.expanded = true;
                        return {...item, menus: filteredMenus};
                    }
                    this.navService.expanded = true;
                    // If no menu matches, but module name matches, return full module
                    return moduleMatches ? item : null;
                }
                return null;
            })
            .filter(item => item !== null); // Remove nulls
    }
}
